import "./_button.scss";

import React from "react";
import {Button as HipoButton} from "@hipo/react-ui-toolkit";
import classNames from "classnames";

import {ButtonProps} from "./Button.types";
import Spinner from "../spinner/Spinner";
import Tooltip from "../tooltip/Tooltip";

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  // eslint-disable-next-line prefer-arrow-callback
  function ButtonComponent(props, ref) {
    const {
      size = "regular",
      typography = "button",
      customClassName,
      tooltipProps,
      ...otherProps
    } = props;
    const className = classNames(customClassName, `button--${size}`, {
      [`typography--${typography}`]: typography
    });
    const button = (
      <HipoButton
        ref={ref}
        customClassName={className}
        customSpinner={<Spinner />}
        {...otherProps}
      />
    );

    return tooltipProps?.content ? (
      <Tooltip
        customClassName={classNames("button-tooltip", tooltipProps.containerClassName)}
        {...tooltipProps}>
        {/* Disabled buttons do not trigger the tooltip. Therefore, this placeholder div is placed over the disabled buttons with zIndex so that tooltip would be triggered. */}
        {props.isDisabled && <div className={"button-tooltip__trigger-placeholder"} />}

        {button}
      </Tooltip>
    ) : (
      button
    );
  }
);

export default Button;
